import { BREAKPOINTS } from '../constants/screen';

export const sortedBreakpoints = Object
  .values(BREAKPOINTS)
  .sort((bpA, brB) => brB.minWidth - bpA.minWidth);

const isBreakpointUp = (width, breakpoint) => (width >= breakpoint.minWidth);
const getWidth = () => Math.max(
  document.documentElement.clientWidth,
  window.innerWidth || 0,
);

export const isTabletUp = () => isBreakpointUp(getWidth(), BREAKPOINTS.TABLET);
export const isDesktopUp = () => isBreakpointUp(getWidth(), BREAKPOINTS.DESKTOP);
export const getBreakpoint = () => {
  const width = getWidth();
  return sortedBreakpoints.find((breakpoint) => isBreakpointUp(width, breakpoint));
};

/**
 * Checks if the user agent has the preference
 * for reduced motion enabled.
 */
export const prefersReducedMotion = () => {
  const match = typeof window.matchMedia !== 'function' ? true :
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  return match;
};
